import styled from 'styled-components';
import { motion } from 'framer-motion';

export const PSACardsDisplayContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 16px;
`;

export const StatusHeader = styled.div`
  width: 100%;
  padding-bottom: 24px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
`;

export const StatusHeaderContainer = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: center;
`;

export const StatusItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: ${props => props.$isSelected ? 'rgba(255, 255, 255, 0.15)' : 'rgba(255, 255, 255, 0.05)'};
  border-radius: 8px;
  border: 1px solid ${props => props.$isSelected ? 'rgba(255, 255, 255, 0.3)' : 'rgba(255, 255, 255, 0.1)'};
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 255, 255, 0.2);
  }
`;

export const StatusName = styled.span`
  font-family: 'Roboto Condensed', sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #FFFFFF;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const StatusCount = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.8);
  background: rgba(255, 255, 255, 0.15);
  padding: 4px 10px;
  border-radius: 12px;
  text-align: center;
`;

export const CardsDisplayContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

export const CardsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 100%;
`;

export const SubmissionGroup = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const SubmissionHeader = styled(motion.div)`
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 12px;
  padding: 16px 20px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.12);
    border-color: rgba(255, 255, 255, 0.25);
  }
`;

export const SubmissionHeaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
`;

export const SubmissionInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
`;

export const SubmissionTitle = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`;

export const SubmissionID = styled.h3`
  color: #FFFFFF;
  font-size: 18px;
  font-weight: 600;
  margin: 0;
`;

export const SubmissionDetails = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.7);
`;

export const SubmissionDetailItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const SubmissionActions = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const GradingDashboard = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
`;

export const DashboardMetric = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px 12px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.15);
`;

export const MetricLabel = styled.span`
  color: rgba(255, 255, 255, 0.6);
  font-size: 11px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const MetricValue = styled.span`
  color: #FFFFFF;
  font-size: 16px;
  font-weight: 600;
`;

export const UnassignedGroup = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const UnassignedHeader = styled.div`
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 16px 20px;
`;

export const UnassignedTitle = styled.h3`
  color: #FFFFFF;
  font-size: 18px;
  font-weight: 600;
  margin: 0;
`;

export const CardItem = styled.div`
  padding: 16px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    background-color: rgba(255, 255, 255, 0.08);
  }
  
  &:active {
    transform: translateY(0);
  }
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: start;
  gap: 12px;
  
  h4 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #FFFFFF;
    flex: 1;
  }
`;

export const StatusBadge = styled.div`
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  background-color: ${({ $status }) => {
    switch ($status) {
      case 'Complete':
        return 'rgba(76, 175, 80, 0.3)';
      case 'Grading in Progress':
        return 'rgba(33, 150, 243, 0.3)';
      case 'Received by PSA':
        return 'rgba(255, 193, 7, 0.3)';
      case 'Shipped to PSA':
        return 'rgba(255, 152, 0, 0.3)';
      case 'PSA Drop Off':
        return 'rgba(156, 39, 176, 0.3)';
      case 'Draft':
        return 'rgba(158, 158, 158, 0.3)';
      default:
        return 'rgba(255, 255, 255, 0.1)';
    }
  }};
  color: #FFFFFF;
  border: 1px solid ${({ $status }) => {
    switch ($status) {
      case 'Complete':
        return 'rgba(76, 175, 80, 0.5)';
      case 'Grading in Progress':
        return 'rgba(33, 150, 243, 0.5)';
      case 'Received by PSA':
        return 'rgba(255, 193, 7, 0.5)';
      case 'Shipped to PSA':
        return 'rgba(255, 152, 0, 0.5)';
      case 'PSA Drop Off':
        return 'rgba(156, 39, 176, 0.5)';
      case 'Draft':
        return 'rgba(158, 158, 158, 0.5)';
      default:
        return 'rgba(255, 255, 255, 0.2)';
    }
  }};
`;

export const CardInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const InfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
`;

export const InfoLabel = styled.span`
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
  font-weight: 500;
`;

export const InfoValue = styled.span`
  font-size: 14px;
  color: #FFFFFF;
  font-weight: 400;
  text-align: right;
`;

export const EmptyState = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 60px 20px;
  text-align: center;
  
  p {
    color: rgba(255, 255, 255, 0.6);
    font-size: 16px;
    margin: 0;
  }
`;

export const ExpandedSection = styled(motion.div)`
  overflow: hidden;
  padding: 12px 24px;
`;

export const SubmissionExpandedContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  align-items: start;
`;

export const SubmissionFormColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const SubmissionCardsColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const FormSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const FormRowContainer = styled.div`
  align-items: end;
  display: flex;
  gap: 16px;
`;

export const FormRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const FormLabel = styled.label`
  font-size: 14px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.8);
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  gap: 12px;
`;